import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getVistaPreviaCorreo } from "../../http/actions/ConfiguracionCorreoClienteAction";

const VistaPreviaCorreoModal = ({ open, onClose, configuracion }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


    const cargarVistaPrevia = useCallback(async () => {
        if (!configuracion?.id) return;
        
        setLoading(true);
        setError("");
        
        try {
        const htmlResponse = await getVistaPreviaCorreo(
            localStorage.getItem("token"), 
            configuracion.id
        );
        setHtmlContent(htmlResponse);
        } catch (error) {
        console.error("Error al cargar vista previa:", error);
        setError("Error al cargar la vista previa del correo");
        } finally {
        setLoading(false);
        }
    }, [configuracion]);

    useEffect(() => {
        if (open && configuracion) {
        cargarVistaPrevia();
        }
    }, [open, configuracion, cargarVistaPrevia]);
  const handleClose = () => {
    setHtmlContent("");
    setError("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '900px'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            Vista Previa - {configuracion?.nombreCliente}
          </Typography>
          <Box>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Divider />
      </DialogTitle>

      <DialogContent sx={{ p: 0, height: '100%' }}>
        {loading ? (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            height="400px"
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box p={3}>
            <Typography color="error" variant="body1">
              {error}
            </Typography>
            <Button 
              variant="outlined" 
              onClick={cargarVistaPrevia}
              sx={{ mt: 2 }}
            >
              Reintentar
            </Button>
          </Box>
        ) : (
          <Box sx={{ height: '100%', overflow: 'auto' }}>
            {/* Simulación del asunto del correo */}
            <Box 
              sx={{ 
                p: 2, 
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #ddd'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                <strong>Para:</strong> usuario@empresa.com<br/>
                <strong>Asunto:</strong> [Alertas Normativas] - {configuracion?.nombreCliente}
              </Typography>
            </Box>
            
            {/* Contenido del correo */}
            <Box sx={{ p: 2, backgroundColor: 'white' }}>
              {htmlContent ? (
                <div 
                  dangerouslySetInnerHTML={{ __html: htmlContent }}
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    lineHeight: '1.4',
                    color: '#333'
                  }}
                />
              ) : (
                <Typography variant="body1" color="text.secondary">
                  No hay contenido para mostrar
                </Typography>
              )}
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #ddd' }}>
        
        <Button 
          onClick={cargarVistaPrevia} 
          variant="contained" 
          disabled={loading}
        >
          Actualizar Vista Previa
        </Button>
        <Button onClick={handleClose}  variant="contained" color="error">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VistaPreviaCorreoModal;